import { apiRequest } from '@/api/client';
import type { ContentAction } from '@cp/shared';
import type { ContentAccessCheck, ContentItemView, ContentOverview, ContentProfileInput, SiteContentView } from '@/types/api';

/** What a person does to an article by its own route; a change of its text is a PATCH. */
export type ContentItemAction = Exclude<ContentAction, 'edit'>;

/** Automatic content (ADR-0051). */
export const contentApi = {
  overview: () => apiRequest<ContentOverview>('/content'),
  site: (siteId: string) => apiRequest<SiteContentView>(`/sites/${siteId}/content`),
  saveProfile: (siteId: string, input: ContentProfileInput) => apiRequest<SiteContentView>(`/sites/${siteId}/content/profile`, { method: 'PUT', body: input }),
  check: (siteId: string) => apiRequest<ContentAccessCheck>(`/sites/${siteId}/content/check`, { method: 'POST', body: {} }),
  requestIdeas: (siteId: string, count: number) => apiRequest<{ requested: boolean }>(`/sites/${siteId}/content/ideas`, { method: 'POST', body: { count } }),
  addIdea: (siteId: string, input: { title: string; keyword: string | null; brief: string | null; write: boolean }) =>
    apiRequest<ContentItemView>(`/sites/${siteId}/content/items`, { method: 'POST', body: input }),
  item: (id: string) => apiRequest<ContentItemView>(`/content/items/${id}`),
  edit: (id: string, input: Record<string, unknown>) => apiRequest<ContentItemView>(`/content/items/${id}`, { method: 'PATCH', body: input }),
  act: (id: string, action: ContentItemAction, body: Record<string, unknown> = {}) => apiRequest<ContentItemView>(`/content/items/${id}/${action}`, { method: 'POST', body }),
};
